import Vue from 'vue'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'

Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)

export default new VueRouter({
  mode: 'history',
  scrollBehavior(/* to, from, savedPosition */) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/login',
      name: 'login',
      component: require('@/views/Login').default
    },
    {
      path: '/shutokou-kiloposts',
      name: 'shutokou-kiloposts',
      component: require('@/views/ShutokouKiloposts').default
    },
    {
      path: '/hokuriku-kiloposts',
      name: 'hokuriku-kiloposts',
      component: require('@/views/HokurikuKiloposts').default
    },
    {
      path: '/nce-kiloposts',
      name: 'nce-kiloposts',
      component: require('@/views/NceKiloposts').default
    },
    {
      path: '/arc-kiloposts',
      name: 'arc-kiloposts',
      component: require('@/views/ArcKiloposts').default
    },
    {
      path: '/ngy-kiloposts',
      name: 'ngy-kiloposts',
      component: require('@/views/NagoyaKiloposts').default
    },
    {
      path: '/nexco-east-niigata-kiloposts',
      name: 'nexco-east-niigata-kiloposts',
      component: require('@/views/NexcoEastNiigataKiloposts').default
    },
    {
      path: '/nexco-east-saitama-kiloposts',
      name: 'nexco-east-saitama-kiloposts',
      component: require('@/views/NexcoEastSaitamaKiloposts').default
    },
    {
      path: '/shikoku-kiloposts',
      name: 'shikoku-kiloposts',
      component: require('@/views/ShikokuKiloposts').default
    },
    {
      path: '/chisei-kiloposts/:chisei',
      name: 'chisei-kiloposts',
      component: require('@/views/ChiseiKiloposts').default
    },
    {
      path: '/kendo-kiloposts/:kendo',
      name: 'kendo-kiloposts',
      component: require('@/views/KendoKiloposts').default
    },
    {
      path: '/fukuoka-kitakyushu-kiloposts',
      name: 'fukuoka-kitakyushu-kiloposts',
      component: require('@/views/FukuokaKitakyushuKiloposts').default
    },
    {
      path: '/honshi-kiloposts',
      name: 'honshi-kiloposts',
      component: require('@/views/HonshiKiloposts').default
    },
    {
      path: '/hitachi-kasen-kiloposts',
      name: 'hitachi-kasen-kiloposts',
      component: require('@/views/HitachiKasenKiloposts').default
    },
    {
      path: '/koufu-kasen-kiloposts',
      name: 'koufu-kasen-kiloposts',
      component: require('@/views/KoufuKasenKiloposts').default
    },
    {
      path: '/miyagi-kiloposts',
      name: 'miyagi-kiloposts',
      component: require('@/views/MiyagiKiloposts').default
    },
    {
      path: '/tokyu-kiloposts',
      name: 'tokyu-kiloposts',
      component: require('@/views/TokyuKiloposts').default
    },
    {
      path: '/hiroshima-airport-kiloposts',
      name: 'hiroshima-airport-kiloposts',
      component: require('@/views/HiroshimaAirportKiloposts').default
    },
    {
      path: '/shinchitose-airport-kiloposts',
      name: 'shinchitose-airport-kiloposts',
      component: require('@/views/ShinchitoseAirportKiloposts').default
    },
    {
      path: '/iwaki-kiloposts',
      name: 'iwaki-kiloposts',
      component: require('@/views/IwakiKiloposts').default
    },
    {
      path: '/yurikamome-kiloposts',
      name: 'yurikamome-kiloposts',
      component: require('@/views/YurikamomeKiloposts').default
    },
    {
      path: '/gunma-kiloposts',
      name: 'gunma-kiloposts',
      component: require('@/views/GunmaKiloposts').default
    },
    {
      path: '/kantou-mc-kiloposts',
      name: 'kantou-mc-kiloposts',
      component: require('@/views/KantouMCKiloposts').default
    },
    {
      path: '/nagano-kiloposts',
      name: 'nagano-kiloposts',
      component: require('@/views/NaganoKiloposts').default
    },
    {
      path: '/joint-touroku',
      name: 'joint-touroku',
      component: () => import(/* webpackChunkName: "jointTouroku" */ '@/views/JointTouroku/JointTouroku'),
    },
    {
      path: '/pole-touroku',
      name: 'pole-touroku',
      component: () => import(/* webpackChunkName: "poleTouroku" */ '@/views//PoleTouroku/PoleTouroku'),
    },
    // catch all
    {
      path: '*',
      redirect: { name: 'shutokou-kiloposts' },
    },
  ]
})
